import { render } from "./TabLink.vue?vue&type=template&id=49a11c8e&scoped=true"
import script from "./TabLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TabLink.vue?vue&type=script&setup=true&lang=js"

import "./TabLink.vue?vue&type=style&index=0&id=49a11c8e&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a11c8e"],['__file',"src/components/tabs/TabLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49a11c8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49a11c8e', __exports__)) {
    console.log('reload')
    api.reload('49a11c8e', __exports__)
  }
  
  module.hot.accept("./TabLink.vue?vue&type=template&id=49a11c8e&scoped=true", () => {
    console.log('re-render')
    api.rerender('49a11c8e', render)
  })

}


export default __exports__